import styled from 'styled-components/native';

import { SortBy } from '../../constants/sortData';
import FilterBar from '../../elements/FilterBar';
import { FilterConfigPage } from '../../types/FilterConfigResponse';
import { VendorBanner } from '../../types/VendorDetail';
import VendorItem from '../VendorItem';
import CollectBtnContent from './CollectBtnContent';
import EventBanner from './EventBanner';
import HeaderBanner from './HeaderBanner';
import ProductCounter from './ProductCounter';
import { hasBannerData } from './utils';
import VendorDescription from './VendorDescription';

interface Props {
  sortBy: SortBy;
  isFetching: boolean;
  id: string;
  description?: string;
  vendorName?: string;
  eventBanner?: VendorBanner;
  headerBanner?: VendorBanner;
  onPanelStateChanged?: (hasPanelShown: boolean) => void;
}

export const FILTER_CONFIG_PAGE = FilterConfigPage.Vendors;

const sortData = [SortBy.CREATE_AT, SortBy.TOTAL_SALES_QUANTITY];

const VendorHeader = ({
  sortBy,
  headerBanner,
  isFetching,
  id,
  vendorName,
  description,
  eventBanner,
  onPanelStateChanged,
}: Props) => {
  return (
    <>
      {hasBannerData(headerBanner) && (
        <HeaderBanner isFetching={isFetching} headerBanner={headerBanner!} />
      )}
      <VendorItem
        id={id}
        collectProps={vendorCollectProps}
        isLoading={!vendorName}
        shouldRenderScore
      />
      {!!description && (
        <>
          <S.Spacing8 />
          <VendorDescription description={description} />
        </>
      )}
      <S.Spacing8 />
      {hasBannerData(eventBanner) && (
        <>
          <EventBanner isFetching={isFetching} eventBanner={eventBanner!} />
          <S.Spacing8 />
        </>
      )}
      <FilterBar
        fetchParams={{ id, page: FILTER_CONFIG_PAGE }}
        useSort
        sortData={sortData}
        sortBy={sortBy}
        onPanelStateChanged={onPanelStateChanged}
      />
      <S.Spacing8 />
      <ProductCounter id={id} />
    </>
  );
};

const S = {
  Spacing8: styled.View`
    background-color: ${({ theme }) => theme.palette.neutralWhite};
    border-color: ${({ theme }) => theme.palette.neutralLight};
    border-top-width: 1px;
    height: 8px;
  `,
};

const vendorCollectProps = {
  BtnContent: CollectBtnContent,
};

export default VendorHeader;
